import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { ParameterModel } from '../../../_models/_index';
import { GeneralService, ParameterService } from '../../../services/_index';

@Component({
    selector: 'app-parameters-grid',
    templateUrl: './parameters-grid.component.html',
    styleUrls: ['./parameters-grid.component.css']
})
export class ParametersGridComponent implements OnInit {

    parameters: ParameterModel[];
    constructor(private parametersService: ParameterService,
        private dialog: MatDialog,
        private generalService: GeneralService) {
        this.parameters = [];
    }

    ngOnInit() {
        this.loadData();
    }

    loadData() {
        this.parametersService.getParameters().then(result => {
            this.parameters = result;
        });
    }

    valueChanged(event: any, target: any, model: ParameterModel) {       
        let message = "האם אתה בטוח שברצונך לערוך פרמטר " + model.displayText + "?";
        this.generalService.showConfirmDialog(message).then(result => {
            if (result) {
                model.value = target.value;
                this.parametersService.editParameter(model).then((model: ParameterModel) => {
                    this.parameters.splice(this.parameters.findIndex(s => s.parameterID == model.parameterID), 1, model);
                });
            }
            else {
                this.generalService.showSnackBar("עריכה בוטלה");
            }

        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/parameters/parameters-grid/parameters-grid.component.ts